<template>
  <v-dialog
    v-model="dialog"
    :scrim="false"
    max-width="820px"
    persistent
    @click:outside="closeAppointment"
  >
    <div class="relative py-4 px-4 md:px-0 w-full bg-grey-lighten-1 overflow-y-scroll">
      <AppointmentTreatmentSelector
        v-if="!step"
        class="ad-body-module"
        @open-treatment-step="step++"
        @close-dialog="closeAppointment"
        @set-allowed-close="setAllowedToClose"
      />
      <TreatmentDetailSelector
        v-if="step === 1"
        class="ad-body-module"
        @back="step--"
        @on-show-settings="onShowSettings"
      />
    </div>
  </v-dialog>
</template>

<script lang="ts">
import AppointmentTreatmentSelector from '@/components/modules/AppointmentTreatmentSelector.vue';
import TreatmentDetailSelector from '@/components/modules/TreatmentDetailSelector.vue';

import { defineComponent } from 'vue';
import {mapState} from 'vuex';
import {mdiClose} from '@mdi/js';
import TreatmentNotesCard from '@/components/cards/TreatmentNotesCard.vue';
import { VDialog } from 'vuetify/components';

export default defineComponent({
  name: 'AppointmentDialog',
  components: {
    VDialog,
    TreatmentNotesCard,
    AppointmentTreatmentSelector,
    TreatmentDetailSelector,
  },
  data() {
    return {
      dialog: true,
      closeIcon: mdiClose,
      step: 0,
      interval: undefined,
      count: 0,
      allowedToClose: true,
    };
  },
  created() {
    if (!this.interval) { this.interval = setInterval(() => {
      this.count++;
    }, 30);
    }
  },
  watch: {
    count() {
      if (this.count > 25 && this.dialog) {
        clearInterval(this.interval);
      }
    },
    appointment() {
      this.count = 0;
      clearInterval(this.interval);
      this.interval = setInterval(() => {
        this.count++;
      }, 30);
    },
  },
  computed: {
    ...mapState(['selectedPatient', 'appointment']),
  },
  methods: {
    closeModal() {
      if (this.allowedToClose) {
        this.$emit('close-dialog');
      }
    },
    setAllowedToClose(value: boolean) {
      this.allowedToClose = value;
    },
    onShowSettings() {
      this.$emit('on-show-settings');
    },
    closeAppointment() {
      if (this.count > 20 && this.allowedToClose) {
        this.$store.dispatch('resetAppointment');
        clearInterval(this.interval);
      }
    },
  },
});
</script>

<style scoped>
.ad-body {
  min-height: 512px;
  max-height: 100%;
  background: #00000030;
}
</style>
